import { AlertCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { CalendarEvent } from '@/services/calendarService';
import { isPast, isToday, differenceInDays } from 'date-fns';

interface DeadlineBadgeProps {
  event: CalendarEvent;
  compact?: boolean;
}

export default function DeadlineBadge({ event, compact = false }: DeadlineBadgeProps) {
  if (event.type !== 'practice_deadline') {
    return null;
  }

  const deadlineDate = new Date(event.start);
  const now = new Date();
  const daysDiff = differenceInDays(deadlineDate, now);
  
  // Non mostrare urgenza per pratiche completate/archiviate
  const isClosedPractice = event.status === 'COMPLETED' || event.status === 'ARCHIVED';

  let variant: 'default' | 'secondary' | 'destructive' | 'outline' = 'secondary';
  let text = 'Scadenza';
  let urgency = '';

  if (isClosedPractice) {
    // Pratica chiusa: mostra solo info neutra
    variant = 'outline';
    urgency = isPast(deadlineDate) ? 'Pratica chiusa' : `Tra ${daysDiff} giorni`;
  } else if (isPast(deadlineDate) && !isToday(deadlineDate)) {
    variant = 'destructive';
    urgency = `Scaduta ${Math.abs(daysDiff)} giorni fa`;
  } else if (isToday(deadlineDate)) {
    variant = 'destructive';
    urgency = 'Scade oggi!';
  } else if (daysDiff <= 7) {
    variant = 'destructive';
    urgency = `Tra ${daysDiff} giorni`;
  } else if (daysDiff <= 30) {
    variant = 'secondary';
    urgency = `Tra ${daysDiff} giorni`;
  } else {
    urgency = `Tra ${daysDiff} giorni`;
  }

  if (compact) {
    return (
      <Badge variant={variant} className="flex items-center gap-1">
        <AlertCircle className="h-3 w-3" />
        <span className="text-xs">{urgency}</span>
      </Badge>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <AlertCircle className={`h-4 w-4 ${
        variant === 'destructive' ? 'text-red-600' : 'text-orange-600'
      }`} />
      <Badge variant={variant} className="flex items-center gap-1">
        <span>{text}</span>
        {urgency && <span className="text-xs">({urgency})</span>}
      </Badge>
    </div>
  );
}


